export default __webpack_public_path__ + "static/media/queue.bf1593ec.png";